export default function PanneProfalux() {
  return (
    <section className="bg-white py-14 md:py-20">
      <div className="max-w-4xl mx-auto px-4 md:px-8">
        <h2 className="text-2xl md:text-3xl font-bold text-brand-blue mb-6">
          Panne de moteur Profalux : symptômes et causes
        </h2>
        <p className="text-brand-text leading-relaxed mb-5">
          Profalux est une marque française reconnue pour ses systèmes de volets roulants intégrant une technologie de fils conducteurs dans les lames du tablier, connue sous le nom de WireFree ou FreeVox. Cette particularité technique signifie que l'alimentation électrique et les commandes transitent directement par les lames, sans câble apparent dans le coffre. Lorsqu'un moteur Profalux tombe en panne, le diagnostic doit impérativement prendre en compte cette architecture électrique unique : une interruption dans la continuité des fils conducteurs peut simuler une panne de moteur alors que le problème vient du tablier lui-même.
        </p>
        <p className="text-brand-text leading-relaxed mb-8">
          Les moteurs Profalux équipent aussi bien des volets filaires que des volets radio. Les modèles radio utilisent un protocole propriétaire qui nécessite une reprogrammation spécifique lors du remplacement. Les versions filaires, quant à elles, dépendent de la qualité des connexions électriques au niveau des lames conductrices. Nos techniciens interviennent sur le Bas-Rhin avec des outils de diagnostic adaptés : testeurs de continuité pour les fils intégrés, analyseurs de protocole radio pour les télécommandes, et multimètres de précision pour le moteur tubulaire. Ils vérifient systématiquement l'état des lames conductrices, la tension d'alimentation aux bornes du moteur et la réception du signal radio avant de conclure à un remplacement nécessaire.
        </p>

        <h3 className="text-xl font-semibold text-brand-blue mb-4">
          Signes courants d'une panne de moteur Profalux
        </h3>
        <ul className="space-y-3 mb-8">
          {[
            "Le volet ne répond plus à la commande murale ni à la télécommande",
            "Le tablier descend partiellement puis s'arrête de façon aléatoire",
            "Mouvements hésitants avec bruit de frottement ou d'arc électrique",
            "Télécommande Profalux dont le voyant rouge reste allumé sans action",
            "Volet fonctionnant en montée mais bloqué en descente, ou inversement",
            "Perte intermittente de la commande radio malgré des piles neuves",
          ].map((item) => (
            <li key={item} className="flex items-start gap-3">
              <span className="w-5 h-5 flex items-center justify-center text-brand-cyan mt-0.5 flex-shrink-0">
                <i className="ri-checkbox-circle-line text-lg"></i>
              </span>
              <span className="text-brand-text text-sm md:text-base">{item}</span>
            </li>
          ))}
        </ul>

        <h3 className="text-xl font-semibold text-brand-blue mb-4">
          Causes principales du dysfonctionnement
        </h3>
        <ul className="space-y-3">
          {[
            "Usure du moteur tubulaire après 12 à 15 ans d'utilisation régulière",
            "Rupture ou oxydation des fils conducteurs intégrés dans les lames",
            "Défaillance de l'électronique de commande radio ou du récepteur embarqué",
            "Mauvais contact électrique entre les lames conductrices du tablier",
            "Surintensité due à un tablier trop lourd ou des glissières mal alignées",
            "Condensateur de démarrage ou platine de fin de course hors service",
          ].map((item) => (
            <li key={item} className="flex items-start gap-3">
              <span className="w-5 h-5 flex items-center justify-center text-brand-cyan mt-0.5 flex-shrink-0">
                <i className="ri-checkbox-circle-line text-lg"></i>
              </span>
              <span className="text-brand-text text-sm md:text-base">{item}</span>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}